import debounce from 'lodash-es/debounce';
import Drift from 'drift-zoom';
import { product_carousels } from '../../sections/INF-ProductOverview/carousel';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';

let driftInstances = [];

const enableZoom = () => {
  driftInstances.forEach((drift) => {
    drift.enable();
  });
};

const disableZoom = () => {
  driftInstances.forEach((drift) => {
    drift.disable();
  });
};

const destroyZoom = () => {
  driftInstances.forEach((drift) => {
    try {
      drift.disable();
      drift.destroy();
    } catch (error) {
      console.warn('Error destroying drift instance:', error);
    }
  });

  driftInstances = [];

  const carousel = document.querySelector('[data-product-images-carousel]');
  if (carousel) {
    carousel.classList.remove('show-zoom');
  }

  document.querySelectorAll('.drift-zoom-pane').forEach((pane) => {
    pane.remove();
  });
};

const handleResize = debounce(() => {
  if (window.innerWidth >= 768) {
    enableZoom();
  } else {
    disableZoom();
  }
}, 250);

const initPhotoswipe = () => {
  const pswpElement = document.querySelector('.pswp');
  const pswpImages = document.querySelectorAll('[data-product-images-carousel] .swiper-slide:not(:has(video))');
  const itemsArray = [];
  const width = window.innerWidth;
  const height = window.innerHeight;
  let startingIndex = 0;

  const pswpPagination = document.querySelector('[data-pswp-pagination]');
  pswpPagination.innerHTML = '';

  pswpImages.forEach((image, i) => {
    const imageNode = image.querySelector('[data-product-images-slide]');
    const imagePath = imageNode.dataset.zoom;
    itemsArray.push({
      src: imagePath,
      w: width,
      h: height,
    });
    const dot = document.createElement('div');
    dot.classList.add('pswp__dot');
    dot.dataset.pswpDot = '';

    if (image.classList.contains('swiper-slide-active')) {
      dot.classList.add('pswp__dot--active');
      startingIndex = i;
    }

    pswpPagination.appendChild(dot);
  });

  const options = {
    spacing: 0,
    index: startingIndex,
    pinchToClose: false,
    closeOnScroll: true,
    closeOnVerticalDrag: false,
    shareEl: false,
    zoomEl: false,
    fullscreenEl: false,
    caption: false,
    maxSpreadZoom: 4,
  };

  const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, itemsArray, options);

  gallery.listen('firstUpdate', () => {
    gallery.listen('parseVerticalMargin', (item) => {
      item.vGap = {
        top: 0,
        bottom: 0,
      };
      item.initialPosition = {
        x: 0,
        y: 0,
      };
    });
  });

  gallery.listen('afterChange', () => {
    const galleryIndex = gallery.getCurrentIndex();
    const dots = document.querySelectorAll('[data-pswp-dot]');
    dots.forEach((dot) => dot.classList.remove('pswp__dot--active'));
    dots[galleryIndex].classList.add('pswp__dot--active');
  });

  gallery.init();

  gallery.listen('initialZoomInEnd', () => {
    setTimeout(() => {
      document.querySelector('[data-pinch]').style.display = 'none';
    }, 3000);
  });
};

// Function to reinitialize zoom after variant changes
const reinitializeZoom = () => {
  // First destroy any existing zoom instances
  destroyZoom();

  // Wait a short delay to ensure DOM is updated
  setTimeout(() => {
    // Skip if we're on mobile
    if (window.innerWidth < 768) {
      return;
    }

    // Find all zoomable images
    const productImages = document.querySelectorAll('[data-zoom]');
    if (productImages.length === 0) {
      console.warn('No zoomable images found during reinitialization');
      return;
    }

    const el = document.querySelector('[data-product-images-carousel]');
    if (!el) {
      console.warn('Product images carousel not found during reinitialization');
      return;
    }

    // Get the carousel instance
    const carousel = product_carousels;
    if (!carousel) {
      console.warn('Product carousel not initialized during reinitialization');
      return;
    }

    // Find or create a zoom container
    let zoomContainer = document.querySelector('[data-zoom-container]');
    if (!zoomContainer) {
      // If no zoom container exists, use the slide container as fallback
      zoomContainer = el;
    }

    // Setup zoom for each image
    // eslint-disable-next-line no-unused-vars
    let successfulZooms = 0;
    productImages.forEach((image) => {
      try {
        // Get the parent slide for this image to use as pane container
        const slideContainer = image.closest('.swiper-slide');
        if (!slideContainer) {
          console.warn('No slide container found for image, skipping zoom initialization');
          return;
        }

        // Ensure the image has a proper src and data-zoom attribute
        if (!image.getAttribute('src') || !image.getAttribute('data-zoom')) {
          console.warn('Image missing src or data-zoom attribute, skipping');
          return;
        }

        // Create the drift instance
        const drift = new Drift(image, {
          paneContainer: slideContainer,
          inlinePane: false,
          zoomFactor: 3,
          containInline: true,
          hoverBoundingBox: true,
        });

        driftInstances.push(drift);
        successfulZooms++;
      } catch (error) {
        console.error('Error initializing drift for image:', error);
      }
    });
  }, 100);
};

export { destroyZoom, reinitializeZoom };
export default () => {
  const initZoom = (e, params) => {
    disableZoom();

    if (window.innerWidth <= 1024) {
      return;
    }

    let carousel = params ? params.carousels : product_carousels;

    const productImages = document.querySelectorAll('[data-zoom]');

    if (productImages.length === 0) {
      return;
    }

    const el = document.querySelector('[data-product-images-carousel]');

    if (productImages.length > 1) {
      // Add click event listeners to each zoomable image
      productImages.forEach((image) => {
        image.addEventListener('click', (event) => {
          // Stop event propagation to prevent carousel slide change
          event.stopPropagation();

          // Toggle zoom class on the carousel container
          const carouselEl = image.closest('[data-product-images-carousel]');
          if (carouselEl) {
            carouselEl.classList.toggle('show-zoom');
          }
        });
      });

      carousel.on('slideChange', () => {
        document.querySelector('[data-product-images-carousel]').classList.remove('show-zoom');
      });

      productImages.forEach((image) => {
        const drift = new Drift(image, {
          paneContainer: image.closest('.swiper-slide'),
          zoomFactor: 3,
          containInline: true,
        });

        driftInstances.push(drift);
      });
    } else {
      // For single image case
      productImages.forEach((image) => {
        image.addEventListener('click', (event) => {
          // Stop event propagation
          event.stopPropagation();

          // Toggle zoom class
          el.classList.toggle('show-zoom');
        });

        const drift = new Drift(image, {
          paneContainer: image.closest('.swiper-slide'),
          zoomFactor: 3,
          containInline: true,
        });

        driftInstances.push(drift);
      });
    }

    window.addEventListener('resize', handleResize);
  };

  const zoomOpenButton = document.querySelector('[data-zoom-open]');

  if (zoomOpenButton) {
    zoomOpenButton.addEventListener('click', initPhotoswipe);
  } else {
    console.warn('Element with [data-zoom-open] not found.');
  }

  document.addEventListener('debouncedProductOverviewCarouselsDidInit', (e, params) => {
    if (document.querySelector('.ProductGrid').dataset.quickViewContainer !== '') {
      initZoom(e, params);
    }
  });
};
